var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPhotoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.383,
    height: 39.297,
    viewBox: "0 0 45.383 39.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6793",
    "data-name": "Path 6793",
    d: "M40.194,19a2.063,2.063,0,0,0-2.063,2.063v14.44a2.063,2.063,0,0,1-2.063,2.063H7.189a2.063,2.063,0,0,1-2.063-2.063V19A2.063,2.063,0,0,1,7.189,16.94h4.126a2.063,2.063,0,0,0,2.063-1.4l1.114-3.383a2.063,2.063,0,0,1,1.96-1.4H27.817a2.063,2.063,0,0,0,0-4.126H16.348a6.189,6.189,0,0,0-5.859,4.229l-.66,2.063H7.189A6.189,6.189,0,0,0,1,19.106v16.5A6.189,6.189,0,0,0,7.189,41.8h28.88a6.189,6.189,0,0,0,6.189-6.189V21.169A2.063,2.063,0,0,0,40.194,19ZM21.629,16.94a8.251,8.251,0,1,0,8.251,8.251A8.251,8.251,0,0,0,21.629,16.94Zm0,12.377a4.126,4.126,0,1,1,4.126-4.126A4.126,4.126,0,0,1,21.629,29.317ZM44.32,6.626H42.257V4.563a2.063,2.063,0,1,0-4.126,0V6.626H36.069a2.063,2.063,0,0,0,0,4.126h2.063v2.063a2.063,2.063,0,1,0,4.126,0V10.751H44.32a2.063,2.063,0,0,0,0-4.126Z",
    transform: "translate(-1 -2.5)",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhotoIcon);
export default __webpack_public_path__ + "static/media/AddPhotoIcon.0b8e64540751e0423df2cba188fbaff8.svg";
export { ForwardRef as ReactComponent };